<div class="w-12 bg-col-w height-100 center p-a-10 p-t-9-s p-b-8-s p-l-6-s p-l-6-r p-r-6-s p-r-6-r pos-relative">
    <button class="pos-absolute top-4 right-4"
            (click)="close()">
        <i class="icon-close"></i>
    </button>
    @switch (isSuccess) {
    @case (false) {
    <p class="h2">{{'Currently Out of Stock' | translate}}</p>
    <p class="p2 col-11 m-t-2 m-t-4-s p-r-11 p-l-11 p-l-6-s p-l-6-m p-r-6-m p-r-6-s">
        {{'Receive an email notification when this item becomes available.' | translate}}
    </p>
    <xnotif-form class="block m-t left"
                 (success)="onSuccess()"
                 (closeForm)="close()"
                 [model]="data.product"></xnotif-form>
    }
    @case (true) {
    <p class="h2">{{'Notification set up!' | translate}}</p>
    <p class="p2 col-11 m-t-2 m-t-4-s">
        {{
        'Thank you for registering your interest in this product. We will send you and email notification as soon as
        this item is back in stock'
        | translate
        }}
    </p>
    }
    }
</div>
